<template>
  <div>
    <PageHeader />
     <b-overlay :show="isLoading">
       <template v-if="trackingLinkDetail">
         <b-row class="mb-3">
           <b-col>
             <h3 class="mb-0">
               {{ trackingLinkDetail.name }}
             </h3>
             <a :href="trackingLinkUrl" target="_blank">{{ trackingLinkUrl }}</a> <br />
             <a :href="trackingLinkDetail.targetUrl" class="text-muted">({{ trackingLinkDetail.targetUrl }})</a>
           </b-col>
           <b-col class="text-right">
             <b-button
                 to="/tracking-link/list"
             >
               {{ $t('buttons.back') }}
             </b-button>
           </b-col>
         </b-row>

         <b-row>
           <b-col lg="4" md="5">
             <b-card sub-title="คลิกทั้งหมด">
               <hr />
               <h2>{{ trackingLinkDetail.totalClick }} <small class="font-size-18">ครั้ง</small></h2>
             </b-card>
             <b-card sub-title="คลิกไม่ซ้ำ">
               <hr />
               <h2>{{ trackingLinkDetail.totalUniqueClick }} <small class="font-size-18">ครั้ง</small></h2>
             </b-card>
           </b-col>
           <b-col lg="8" md="7">
             <b-card sub-title="ข้อมูล">
               <hr />
               <b-input-group class="mb-3">
                 <b-form-datepicker
                     v-model="startDate"
                     :max="endDate"
                     reset-button
                 ></b-form-datepicker>
                 <b-input-group-append is-text>ถึง</b-input-group-append>
                 <b-form-datepicker v-model="endDate" :max="new Date()" :min="startDate" reset-button></b-form-datepicker>
                 <b-button variant="primary" @click="fetch">
                   <i class="uil uil-search"></i>
                 </b-button>
               </b-input-group>
               <b-row>
                 <b-col class="mb-2" cols="12">
                   <span class="text-muted">สมัครสมาชิก</span>
                   <h2 class="my-0">
                     {{ trackingLinkDetail.totalRegister }}
                     <small class="font-size-18">ยูส</small>
                   </h2>
                 </b-col>

                 <b-col class="mb-2" cols="6">
                   <span class="text-muted">ฝาก</span>
                   <h2 class="my-0 d-inline mr-1">
                     {{ trackingLinkDetail.totalDepositCount | money }}
                     <small class="font-size-18">ครั้ง</small>
                   </h2>
                   <span class="text-muted">({{ +(trackingLinkDetail.totalDepositUserCount || 0).toLocaleString() }} ยูส)</span>
                 </b-col>
                 <b-col class="mb-2" cols="6">
                   <span class="text-muted">จำนวน</span>
                   <h2 class="my-0">
                     {{ trackingLinkDetail.totalDepositAmount | currency }}
                     <small class="font-size-18">บาท</small>
                   </h2>
                 </b-col>
                 <b-col cols="6">
                   <span class="text-muted">ถอน</span>
                   <h2 class="my-0 d-inline mr-1">
                     {{ trackingLinkDetail.totalWithdrawCount | money }}
                     <small class="font-size-18">ยูส</small>
                   </h2>
                   <span class="text-muted">({{ +(trackingLinkDetail.totalWithdrawUserCount || 0).toLocaleString() }} ยูส)</span>
                 </b-col>
                 <b-col cols="6">
                   <span class="text-muted">จำนวน</span>
                   <h2 class="mt-0 mb-1">
                     {{ trackingLinkDetail.totalWithdrawAmount | currency }}
                     <small class="font-size-18">บาท</small>
                   </h2>
                 </b-col>
               </b-row>
             </b-card>
           </b-col>

           <b-col cols="12">
             <b-card sub-title="ยูสที่สมัครสมาชิก">
               <div style="overflow-y: auto; max-height: 500px;">
                 <b-table :fields="fields" :items="items" striped>
                   <template #cell(#)="data">
                     {{ (pagination.currentPage - 1) * pagination.limit + data.index + 1 }}
                   </template>

                   <template #cell(username)="data">
                     <b-link :to="`/players/detail/${data.item.id}`" target="_blank">
                       {{ data.value }}
                     </b-link>
                     <br>
                     <small class="text-muted">({{ data.item.codeName }})</small>
                   </template>

                   <template #cell(userCredit)="data">
                     {{ data.item.userCredit.credit | currency }}
                   </template>

                   <template #cell(totalDeposit)="data">
                     {{ data.value | currency }}
                   </template>

                   <template #cell(totalWithdraw)="data">
                     {{ data.value | currency }}
                   </template>

                   <template #cell(totalBonus)="data">
                     {{ data.value | currency }}
                   </template>

                   <template #cell(createdAt)="data">
                     {{ data.value | datetime }}
                   </template>
                 </b-table>
               </div>

               <b-row>
                 <b-col>
                   <LimitSelect v-model="pagination.limit" class="mb-3" />
                 </b-col>
                 <b-col>
                   <PaginationInput
                       :per-page="pagination.limit"
                       :total="trackingLinkDetail.users.length"
                       @update="(val) => (pagination.currentPage = val)"
                   />
                 </b-col>
               </b-row>
             </b-card>
           </b-col>

           <b-col cols="12">
             <b-card
                 v-for="trackingPromotion in trackingLinkDetail.promotions"
                 :key="trackingPromotion.id"
                 body-class="pt-0"
                 header-class="pb-0"
             >
               <template #header>
                 <b class="font-size-22 text-success">{{ trackingPromotion.promotionName }}</b>
               </template>
               <hr class="mt-3">
              <b-row>
                <b-col cols="6" md="3">
                  <span class="text-muted">รับโปรโมชั่น</span>
                  <h2 class="mt-0">
                    {{ trackingPromotion.totalUserCount | money }} <small class="font-size-18">ยูส</small> /
                    {{ trackingPromotion.totalClaimCount | money }} <small class="font-size-18">ครั้ง</small>
                  </h2>
                </b-col>
                <b-col cols="6" md="3">
                  <span class="text-muted">โบนัส</span>
                  <h2 class="mt-0">{{ trackingPromotion.totalBonusAmount | currency }} <small class="font-size-18">เครดิต</small></h2>
                </b-col>
                <b-col cols="6" md="3">
                  <span class="text-muted">ฝาก</span>
                  <h2 class="mt-0">{{ trackingPromotion.totalDepositAmount | currency }} <small class="font-size-18">บาท</small></h2>
                </b-col>
                <b-col cols="6" md="3">
                  <span class="text-muted">ถอน</span>
                  <h2 class="mt-0">
                    {{ trackingPromotion.totalWithdrawCount | money }} <small class="font-size-18">ครั้ง</small> /
                    {{ trackingPromotion.totalWithdrawAmount | currency }} <small class="font-size-18">บาท</small>
                  </h2>
                </b-col>
              </b-row>
             </b-card>
           </b-col>
         </b-row>
       </template>
     </b-overlay>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  page: {
    title: 'ลิงค์การตลาด',
  },
  data() {
    return {
      isLoading: false,
      trackingLink: null,
      startDate: new Date(),
      endDate: new Date(),
      pagination: {
        limit: 20,
        currentPage: 1,
      },
      fields: [
        '#',
        {
          key: 'username',
          label: this.$t('user.username'),
        },
        {
          key: 'userCredit',
          label: this.$t('fields.credit'),
        },
        {
          key: 'totalDeposit',
          label: 'ยอดฝาก',
        },
        {
          key: 'totalWithdraw',
          label: 'ยอดถอน',
        },
        {
          key: 'totalBonus',
          label: 'ยอดโบนัส',
        },
        {
          key: 'createdAt',
          label: this.$t('user.registered_date'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['trackingLinkDetail', 'trackingLinkDetail.totalRegister']),
    trackingLinkId() {
      return this.$route.params.id
    },
    trackingLinkUrl() {
      const baseUrl = process.env.VUE_APP_TRACKING_BASE_URL.endsWith('/') ? process.env.VUE_APP_TRACKING_BASE_URL : process.env.VUE_APP_TRACKING_BASE_URL + '/'
      return baseUrl + this.trackingLinkDetail.trackingCode
    },
    items() {
      if (!this.trackingLinkDetail || !this.trackingLinkDetail.users) {
        return []
      }
      const start = (this.pagination.currentPage - 1) * this.pagination.limit
      const end = start + this.pagination.limit
      return this.trackingLinkDetail.users.slice(start, end)
    }
  },
  async created() {
    await this.fetch()
  },
  methods: {
    ...mapActions(['fetchTrackingLinkData']),
    async fetch() {
      this.isLoading = true
      await this.fetchTrackingLinkData({
        id: this.trackingLinkId,
        startDate: this.startDate,
        endDate: this.endDate,
      })
      this.isLoading = false
    }
  },
}
</script>